import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Badge,
  Box,
  Button,
  Flex,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import CpsSettlementBreakdown from "../CpsSettlementBreakdown";

function money(v) {
  const n = Number(v ?? 0);
  return `₩${n.toLocaleString()}`;
}

function statusColor(st) {
  const s = String(st ?? "").toUpperCase();
  if (s === "CONFIRMED") return "green";
  if (s === "REQUESTED") return "blue";
  if (s === "DRAFT") return "purple";
  if (s === "CANCELED") return "gray";
  return "gray";
}

export default function CpsSettlementCampaignList({
  item,
  onRequest,
  onPayCommissions,
  payCommissionsBusyId,
}) {
  return (
    <Accordion allowMultiple w="100%">
      <AccordionItem
        border="1px solid"
        borderColor="rgba(0, 84, 192, 0.14)"
        bg="white"
        borderRadius="12px"
        mb="8px"
        boxShadow="0 1px 3px rgba(23, 41, 64, 0.08)"
        overflow="hidden"
      >
        <AccordionButton py="14px" px="18px" _hover={{ bg: "gray.50" }}>
          <Flex w="100%" align="center" justify="space-between" gap="12px">
            <Text fontSize="20px" fontWeight="700" color="#172940" noOfLines={1}>
              {item.campaignTitle}
            </Text>
            <Flex align="center" gap="10px" flexShrink={0} flexWrap="wrap" justify="flex-end">
              <Flex
                align="center"
                gap="8px"
                px="14px"
                py="8px"
                bg="white"
                borderRadius="8px"
                border="1px solid"
                borderColor="gray.200"
              >
                <Text fontSize="13px" color="#5D6979">클릭수</Text>
                <Text fontSize="15px" fontWeight={700} color="#0054C0">
                  {Number(item.totalClicks ?? 0).toLocaleString()}회
                </Text>
              </Flex>
              <Flex
                align="center"
                gap="8px"
                px="14px"
                py="8px"
                bg="white"
                borderRadius="8px"
                border="1px solid"
                borderColor="gray.200"
              >
                <Text fontSize="13px" color="#5D6979">총 판매수</Text>
                <Text fontSize="15px" fontWeight={700} color="#0054C0">
                  {Number(item.totalSalesCount ?? 0).toLocaleString()}건
                </Text>
              </Flex>
              <Flex
                align="center"
                gap="8px"
                px="14px"
                py="8px"
                bg="white"
                borderRadius="8px"
                border="1px solid"
                borderColor="gray.200"
              >
                <Text fontSize="13px" color="#5D6979">판매수량</Text>
                <Text fontSize="15px" fontWeight={700} color="#0054C0">
                  {Number(item.totalQuantity ?? 0).toLocaleString()}개
                </Text>
              </Flex>
              <Flex
                align="center"
                gap="8px"
                px="14px"
                py="8px"
                bg="white"
                borderRadius="8px"
                border="1px solid"
                borderColor="gray.200"
              >
                <Text fontSize="13px" color="#5D6979">원고료</Text>
                <Text fontSize="15px" fontWeight={700} color="#0054C0">
                  {money(item.manuscriptFee)}
                </Text>
              </Flex>
              <Flex
                align="center"
                gap="8px"
                px="14px"
                py="8px"
                bg="white"
                borderRadius="8px"
                border="1px solid"
                borderColor="gray.200"
              >
                <Text fontSize="13px" color="#5D6979">커미션</Text>
                <Text fontSize="15px" fontWeight={700} color="#0054C0">
                  {money(item.totalCommission)}
                </Text>
              </Flex>
              <Flex
                align="center"
                gap="8px"
                px="14px"
                py="8px"
                bg="white"
                borderRadius="8px"
                border="1px solid"
                borderColor="gray.200"
              >
                <Text fontSize="13px" color="#5D6979">ROAS</Text>
                <Text fontSize="15px" fontWeight={700} color="#0054C0">
                  {Number(item.roas ?? 0).toFixed(1)}%
                </Text>
              </Flex>
              <AccordionIcon fontSize="22px" color="#0054C0" />
            </Flex>
          </Flex>
        </AccordionButton>

        <AccordionPanel bg="#FAFCFF" px="18px" pt="14px" pb="18px">
          <SimpleGrid columns={{ base: 1, xl: 2, "2xl": 3 }} spacing="14px">
            {item.creators.map((creator) => (
              <Box
                key={creator.cpsSettlementId}
                border="1px solid"
                borderColor="gray.200"
                borderRadius="12px"
                bg="white"
                p="14px"
                boxShadow="0 2px 8px rgba(23, 41, 64, 0.08)"
                overflow="hidden"
              >
                <Flex
                  direction={{ base: "column", lg: "row" }}
                  align={{ base: "stretch", lg: "flex-start" }}
                  gap={4}
                >
                  <Flex
                    direction="column"
                    width={{ base: "100%", lg: "200px" }}
                    minW={{ base: "100%", lg: "200px" }}
                    flexShrink={0}
                    gap={2}
                    bg="#F7FAFC"
                    borderRadius="10px"
                    p="10px"
                  >
                    <Flex align="center" gap={2} justify="space-between" wrap="wrap">
                      <Flex align="center" gap={2}>
                        <Text fontSize="16px" fontWeight="700" color="#172940">
                          {creator.creatorDisplayName ?? "-"}
                        </Text>
                        <Badge colorScheme={statusColor(creator.status)}>
                          {creator.status}
                        </Badge>
                      </Flex>
                      {String(creator.status).toUpperCase() === "DRAFT" ? (
                        <Button
                          size="sm"
                          colorScheme="blue"
                          onClick={() => onRequest?.(creator.cpsSettlementId)}
                        >
                          발송
                        </Button>
                      ) : String(creator.status).toUpperCase() === "REQUESTED" ? (
                        <Text fontSize="13px" fontWeight="700" color="#0054C0">
                          발송완료
                        </Text>
                      ) : String(creator.status).toUpperCase() === "CONFIRMED" ? (
                        <Flex align="center" gap={2} wrap="wrap">
                          <Text fontSize="13px" fontWeight="700" color="#0054C0">
                            발송완료
                          </Text>
                          {creator.commissionsPaidAt ? (
                            <Text fontSize="13px" fontWeight="700" color="green.600">
                              커미션 지급완료
                            </Text>
                          ) : (
                            <Button
                              size="sm"
                              colorScheme="blue"
                              isLoading={payCommissionsBusyId === creator.cpsSettlementId}
                              onClick={() => onPayCommissions?.(creator.cpsSettlementId)}
                            >
                              커미션 지급
                            </Button>
                          )}
                        </Flex>
                      ) : null}
                    </Flex>
                    <Text fontSize="13px" color="#5D6979">
                      클릭수 {Number(creator.totalClicks ?? 0).toLocaleString()}회
                    </Text>
                    <Text fontSize="13px" color="#5D6979">
                      ROAS {Number(creator.roas ?? 0).toFixed(1)}%
                    </Text>
                  </Flex>
                  <Box
                    flex="1"
                    minW="0"
                    overflow="hidden"
                    borderLeftWidth={{ base: "0", lg: "1px" }}
                    borderColor="gray.200"
                    pl={{ base: 0, lg: 4 }}
                  >
                    <CpsSettlementBreakdown detail={creator} />
                  </Box>
                </Flex>
              </Box>
            ))}
          </SimpleGrid>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
